type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
  fillColor?: string;
};

const EyeClosedIcon = ({
  width = '12',
  height = '12',
  strokeColor = '#F3E9D7',
  fillColor = 'none',
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill={fillColor}
    >
      <path
        d="M2.25 1.875L9.75 10.125"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26159 7.38438C6.8936 7.71892 6.40779 7.89358 5.91102 7.86993C5.41425 7.84629 4.94723 7.62627 4.61268 7.25828C4.27814 6.89029 4.10348 6.40448 4.12712 5.90771C4.15077 5.41095 4.37079 4.94392 4.73878 4.60938"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.35352 4.15625C6.75214 4.23259 7.11523 4.43621 7.38825 4.73653C7.66127 5.03684 7.82947 5.41764 7.86758 5.82172"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77824 7.92657C10.8001 7.01157 11.2496 6.00001 11.2496 6.00001C11.2496 6.00001 9.74965 2.62501 5.99965 2.62501C5.67491 2.62456 5.35068 2.6509 5.03027 2.70376"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.46875 3.21094C1.55766 4.17844 0.75 5.99531 0.75 5.99531C0.75 5.99531 2.25 9.37031 6 9.37031C6.87868 9.3772 7.74636 9.17474 8.53125 8.77969"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeClosedIcon;
